import React, { Component } from "react";
import styles from "../Faqs/faqStyle.module.css";
import Mail from "../../commomComponents/mail";
import ReactHtmlParser from "react-html-parser";
import getFaqDetails from "../../services/request/faq";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";

export default class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banner: [],
      faqList: [],
      isLoading: true,
    };
  }
  componentWillMount = () => {
    document.title =
      "Frequently Asked Questions - ICICI Pru Alternates Support";
    this.callAllApis();
  };
  callAllApis = () => {
    this.setState({ isLoading: true });
    const Faq = getFaqDetails();

    Faq.then((data) => {
      this.setState({
        isLoading: false,
        faqList: data.data.faq,
        banner: data.data.banner[0],
      });
    });
  };
  sortObject = (obj, sortBy) => {
    let sortedObj = obj.sort(
      (a, b) => parseFloat(a[sortBy]) - parseFloat(b[sortBy])
    );
    return sortedObj;
  };

  render() {
    const { faqList, banner, isLoading } = this.state;
    const faq = this.sortObject(
      faqList.filter((data) => data.id !== 8),
      "id"
    );
    console.log(faq, "faq");
    return (
      <div className={styles.faqSection}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <SeoHelmet
              title="Frequently Asked Questions - ICICI Pru Alternates Support"
              description="Get all your queries resolved with ICICI Pru Alternates FAQs. Learn about our portfolio management, investment strategies, and more to make informed decisions."
              url="https://www.iciciprualternates.com/faqs"
            />
            <Mail />
            <BannerWithHeading
              bannerImage={IMAGE_URL + banner.image + SITE_ID}
              heading={banner.title}
            />
            <div className={styles.section}>
              <div className={styles.container}>
                {faq.map((data) => {
                  return (
                    <div>
                      <div className={styles.question}>{data.question}</div>
                      <p className={styles.answer}>
                        {ReactHtmlParser(data.answer)}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
